import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { extensionsApi } from "@/lib/api";
import type { DialplanExtensionCreate, DialplanExtensionUpdate } from "@/types";

export function useExtensions(contextId?: string) {
  return useQuery({
    queryKey: ["extensions", contextId],
    queryFn: () => extensionsApi.list(contextId ? { context_id: contextId } : {}),
  });
}

export function useExtension(id: string) {
  return useQuery({
    queryKey: ["extensions", id],
    queryFn: () => extensionsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateExtension() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: DialplanExtensionCreate) => extensionsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["extensions"] }),
  });
}

export function useUpdateExtension() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: DialplanExtensionUpdate;
    }) => extensionsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["extensions"] }),
  });
}

export function useDeleteExtension() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => extensionsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["extensions"] }),
  });
}
